export default __webpack_public_path__ + "static/media/accident_report_card_background.c4a1f05a.png";